/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-linkedin': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.681 8.878C5.753 8.878 5 8.109 5 7.181a1.68 1.68 0 113.362 0c0 .928-.753 1.697-1.681 1.697zM8.134 19.5H5.231v-9.347h2.903V19.5zm7.967 0H19v-5.134c0-2.513-.54-4.448-3.478-4.448-1.412 0-2.358.775-2.746 1.51h-.04v-1.275H9.952V19.5h2.9V14.87c0-1.218.231-2.396 1.74-2.396 1.487 0 1.51 1.39 1.51 2.475v4.55z" _fill="#fff"/>'
  }
})
